import { Typography, useUiBaseConfig } from '@faceup/ui-base'
import type { ReactNode } from 'react'

type SummaryFieldProps = {
  label: ReactNode
  value: ReactNode
  dataTest?: string
}

export const SummaryField = ({ label, value, dataTest }: SummaryFieldProps) => {
  const { token } = useUiBaseConfig()

  return (
    <div className='flex flex-col gap-1 min-w-[200px] flex-1'>
      <Typography.Text strong size='sm' style={{ color: token.colorTextSecondary }}>
        {label}
      </Typography.Text>
      <Typography.Text strong data-test={dataTest}>
        {value}
      </Typography.Text>
    </div>
  )
}
